module.exports = __webpack_public_path__ + "355CC9_0_0.ttf?858126b73aa6891c603e4d5eee82845f";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/355CC9_0_0.ttf
// module id = 9
// module chunks = 0